import { render, staticRenderFns } from "./jumpPageSannuo.vue?vue&type=template&id=382bdad4&"
import script from "./jumpPageSannuo.vue?vue&type=script&lang=js&"
export * from "./jumpPageSannuo.vue?vue&type=script&lang=js&"
import style0 from "./jumpPageSannuo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports